import { render } from "./RegisterHouseholdModal.vue?vue&type=template&id=622b9e4a&scoped=true"
import script from "./RegisterHouseholdModal.vue?vue&type=script&lang=js"
export * from "./RegisterHouseholdModal.vue?vue&type=script&lang=js"

import "./RegisterHouseholdModal.vue?vue&type=style&index=0&id=622b9e4a&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622b9e4a"]])

export default __exports__